import firebase from "firebase";

export async function checkAccount(email){
	var functions = firebase.app().functions('europe-west1');
	var checkAccount = functions.httpsCallable('checkAccount');
	return await checkAccount(email);
}

export async function processAccountSetUp(id){
	var functions = firebase.app().functions('europe-west1');
	var processAccountSetUp = functions.httpsCallable('processAccountSetUp');
	return await processAccountSetUp(id);
}
export async function getPasswordResetLink(email){
	var functions = firebase.app().functions('europe-west1');
	var getPasswordResetLink = functions.httpsCallable('getPasswordResetLink');
	return await getPasswordResetLink(email);
}